import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table          : 'CI_ITEM',
    fieldMap       : {
        id              : 'CI_ID',
        key             : 'CI_KEY',
        name            : 'CI_NAME',
        itemTypeId      : 'CI_CIT_ID',
        statusId        : 'CI_CIST_ID',
        creatorUserId   : 'CI_CREATOR',
        creationTime    : 'CI_CREATION_TIME',
        modifierUserId  : 'CI_MODIFIER',
        modificationTime: 'CI_MODIFICATION_TIME',
        validatorUserId : 'CI_VALIDATOR',
        validationTime  : 'CI_VALIDATION_TIME'
    },
    historyFieldMap: {
        id            : 'CI_ID',
        key           : 'CI_KEY',
        name          : 'CI_NAME',
        itemTypeId    : 'CI_CIT_ID',
        statusId      : 'CI_CIST_ID',
        modifierUserId: 'CI_MODIFIER',
        validFromTime : 'CI_VALID_FROM',
        validToTime   : 'CI_VALID_TO'
    },
    fieldTypesMap  : {
        id              : 'INTEGER',
        key             : 'STRING',
        name            : 'STRING',
        itemTypeId      : 'INTEGER',
        statusId        : 'INTEGER',
        creatorUserId   : 'STRING',
        creationTime    : 'TIMESTAMP',
        modifierUserId  : 'STRING',
        modificationTime: 'TIMESTAMP',
        validatorUserId : 'STRING',
        validationTime  : 'TIMESTAMP',
        validFromTime   : 'TIMESTAMP',
        validToTime     : 'TIMESTAMP'
    }
};

export default tableDefinition;
